import { Component, Prop } from '@stencil/core';
import { Price } from '../../../types/types';
import { Unsubscribe } from '@stencil/redux';
import { store } from '../../../redux/store';
import { RootState } from '../../../redux/reducers';
import { formatPrice, t } from '../../../redux/utils';

@Component({
  tag: 'rentware-deposit-price',
  shadow: false,
})
export class RentwareDepositPrice {
  @Prop({ mutable: true }) displayNet: boolean;
  @Prop() price: Price;

  unsubscribe!: Unsubscribe;

  componentWillLoad() {
    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      return {
        displayNet: state.system.pricing.priceDisplay === 'net',
      };
    });
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  get transParams() {
    const price = (this.displayNet && this.price.net) || this.price.gross;
    return { amount: formatPrice(price) };
  }

  render() {
    if (!this.price || this.price.gross === 0) {
      return null;
    }

    return t('cart.deposit', this.transParams);
  }
}
